// extracted by mini-css-extract-plugin
export default {"container":"VerifyEmail_container__eBHYq","messageContainer":"VerifyEmail_messageContainer__ZwYw5"};